export default __webpack_public_path__ + "static/media/logo-main.45f78a6e.png";